import { Floater } from './Floater';

export class Hotspot {
  constructor(data = {}) {
    const {
      floor_id,
      floorId = floor_id,
      id,
      image,
      minimap_id,
      minimapId = minimap_id,
      rotation,
      type,
      x,
      x1,
      y,
      y1,
      links = [],
      title,
    } = data;

    Object.assign(this, {
      id,
      image,
      minimapId,
      rotation: +rotation,
      type,
      floorId: +floorId,
      x: +x,
      x1: +x1,
      y: +y,
      y1: +y1,
      links: links.map(data => new Floater(data, id)),
      title,
    });
  }

  extend(data) {
    return new Hotspot(Object.assign({}, this, data));
  }
}
